import AdvertsContainer from '../../adverts/containers/AdvertsContainer';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import Transactions from '../presentational/Transactions';
import useTransactions from '../hooks/useTransactions';
import useTranslate from 'lib/languages/useTranslate';
import { useHistory } from 'react-router-dom';
import Button from 'components/shared/generic/button/presentational/Button';
import useAccountMigrationCheck from 'lib/hooks/useAccountMigrationCheck';
import ActivateCardBanner from '../presentational/ActivateCardBanner';
import { TransactionType } from 'lib/type';
import { TRANSACTIONS } from 'constants/shared/routes';

const HomeTransactions = () => {
    const translate = useTranslate('transactionsList');
    const history = useHistory();
    const token = localStorage.getItem('accessToken') as string;
    const {
        isAccountMigrated,
        selectedAccountCardProvider,
    } = useAccountMigrationCheck(token);

    const { transactions, isFetchingTransactions, error } = useTransactions(
        isAccountMigrated ? selectedAccountCardProvider : null,
    );

     const limitedTransactions = [
        transactions.find(t => t.type === TransactionType.ACCOUNT_BALANCE),
        ...transactions.filter(t => t.type !== TransactionType.ACCOUNT_BALANCE && t.type !== TransactionType.SECTION_HEADER).slice(0, 5),
    ].filter(Boolean);

    const onlyTransactions = limitedTransactions.filter(t => t.type !== TransactionType.ACCOUNT_BALANCE);

    return (
        <PageContainer className="transactions-container">
            <AdvertsContainer />
            <ActivateCardBanner />
            <DataCheck
                className="transactions-scroll-container"
                data={onlyTransactions}
                error={(error as any)?.data?.message}
                noDataMessage={translate('noDataMessage')}
                isLoading={isFetchingTransactions}
            >
                <Transactions
                    data={limitedTransactions}
                />
                <Button onClick={() => history.push(TRANSACTIONS)}>
                    {translate('buttonText')}
                </Button>
            </DataCheck>
        </PageContainer>
    );
};

export default HomeTransactions;
